import { designSystemColors, otherColors } from '@klv/shared/styles/colors';

const archiveCard = {
  backgroundColor: {
    white: designSystemColors.white,
    lightSand: designSystemColors.lightSand,
  },
  borderRadius: '1.2rem',
  boxShadow: otherColors.archiveCardBoxShadow,
  categoryTitleColor: designSystemColors.poppy,
  postTitleColor: otherColors.gray90,
};

export default archiveCard;
